// extracted by mini-css-extract-plugin
export default {"OrderButton":"MakeOrderModal_OrderButton__DUMDQ","OrderData":"MakeOrderModal_OrderData__CCru7"};